import { useEffect, useState } from 'react'

/** Tick leve pra re-renderizar rótulos relativos de presença. Não faz I/O. */
export function usePresenceTick(intervalMs = 30_000): number {
  const [now, setNow] = useState(() => Date.now())
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), intervalMs)
    return () => clearInterval(id)
  }, [intervalMs])
  return now
}
